import React from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';

const Footer = ({ company, onNavigate }) => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { label: 'Home', id: 'home' },
    { label: 'About', id: 'about' },
    { label: 'Products', id: 'products' },
    { label: 'Why Us', id: 'why-choose-us' },
    { label: 'Testimonials', id: 'testimonials' },
    { label: 'Contact', id: 'contact' }
  ];

  return (
    <footer className="bg-slate-900 text-slate-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Company Info */}
          <div>
            <h3 className="text-2xl font-bold text-white mb-4">{company.name}</h3>
            <p className="text-slate-400 mb-6 leading-relaxed">
              Your trusted partner for premium bitumen export solutions worldwide. Quality assured, globally delivered.
            </p>
            <div className="space-y-3">
              <a href={`tel:${company.phone}`} className="flex items-center hover:text-amber-400 transition-colors duration-300">
                <Phone className="w-5 h-5 mr-3 text-amber-500" />
                {company.phone}
              </a>
              <a href={`mailto:${company.email}`} className="flex items-center hover:text-amber-400 transition-colors duration-300">
                <Mail className="w-5 h-5 mr-3 text-amber-500" />
                {company.email}
              </a>
              <div className="flex items-center">
                <MapPin className="w-5 h-5 mr-3 text-amber-500" />
                {company.address}
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold text-white mb-4">Quick Links</h4>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.id}>
                  <button
                    onClick={() => onNavigate(link.id)}
                    className="hover:text-amber-400 transition-colors duration-300 hover:translate-x-1 inline-block"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Products */}
          <div>
            <h4 className="text-lg font-bold text-white mb-4">Our Products</h4>
            <ul className="space-y-2">
              <li className="hover:text-amber-400 transition-colors duration-300">Penetration Grade Bitumen</li>
              <li className="hover:text-amber-400 transition-colors duration-300">Viscosity Grade Bitumen</li>
              <li className="hover:text-amber-400 transition-colors duration-300">Oxidized Bitumen</li>
              <li className="hover:text-amber-400 transition-colors duration-300">Cutback Bitumen</li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-slate-800">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-slate-400 text-sm mb-4 md:mb-0">
              © {currentYear} {company.name}. All rights reserved.
            </p>
            <p className="text-slate-400 text-sm">
              Premium Bitumen Export Solutions
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
